<template>
  <v-footer padless class="mb-n3 mt-7">
    <v-card
      flat
      class="primary primary2--text"
      width="100%"
      v-for="(item, index) in footerItems"
      :key="index"
    >
      <v-card-text class="primary2--text mt-5">
        <v-row>
          <v-col cols="12" sm="3" class="d-flex justify-center">
            <v-img
              src="@/assets/LogoVertical.png"
              alt="Logo2"
              contain
              transition="scale-transition"
              max-width="120"
              max-height="120"
              class="mx-auto"
            />
          </v-col>
          <v-col cols="6" xs="6" sm="4" md="3">
            <div v-for="legal in legalItems" :key="legal.id">
              <p class="black--text font-weight-medium">{{ legal.name }}</p>
              <p v-for="subtitle in legal.subtitles" :key="subtitle.id">
                <span @click="insertRoute(subtitle.to)" style="cursor: pointer">{{
                  subtitle.name
                }}</span>
              </p>
            </div>
          </v-col>
          <v-col cols="6" xs="6" sm="4" md="3">
            <div v-for="contact in contactItems" :key="contact.id">
              <p class="black--text font-weight-medium">{{ contact.name }}</p>
              <p v-for="contact in contact.contacts" :key="contact.id">
                <v-icon>{{ contact.icon }}</v-icon>
                <span class="ml-2">{{ contact.info }}</span>
              </p>
            </div>
          </v-col>
          <v-col cols="6" xs="6" sm="1" md="3">
            <div v-for="socialNet in socialNetItems" :key="socialNet.id">
              <p class="black--text font-weight-medium">{{ socialNet.name }}</p>
              <div class="d-flex flex-wrap">
                <p icon v-for="icon in socialNet.icons" :key="icon.id" class="flex-grow-0 mr-8">
                  <v-icon size="28px" @click="insertRoute(icon.to)">{{ icon.icon }}</v-icon>
                </p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text class="primary2--text text-center pa-0">
        <p>{{ item.appName }} © {{ new Date().getFullYear() }}. Todos los derechos reservados</p>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: 'VCardFooter',
  props: ['footerItems', 'legalItems', 'contactItems', 'socialNetItems'],
  data() {
    return {
      property: 'value',
    };
  },
  methods: {
    insertRoute(ruta) {
      this.$router.push(ruta);
      this.$route.query;
    },
  },
};
</script>
